import { Ref } from "react";
import cx from "classnames";

import BaseInput, { InputProps } from "./BaseInput";

import styles from "../../styles/TextArea.module.less";

/** Exactly one of these, so a textarea always has an accessible name. Pass `label` for a visible
 * one parked above the text, or `aria-label` where surrounding copy already names the field. */
type TextAreaLabel =
  | { label: string; "aria-label"?: never }
  | { label?: never; "aria-label": string };

type TextAreaProps = Omit<InputProps, "preIcon" | "status"> &
  TextAreaLabel & {
    /** "s" suits a control that takes a sentence or two rather than a body of text. */
    size?: "s" | "m";
    ref?: Ref<HTMLTextAreaElement>;
  };

const TextArea = ({
  className: containerClassName,
  label,
  "aria-label": ariaLabel,
  size = "m",
  ref,
  ...other
}: TextAreaProps) => {
  return (
    <BaseInput
      multiline={true}
      styles={{ container: containerClassName }}
      {...other}
      renderInputDisplay={({ onChange, preIcon, status, className, ...inputProps }) => {
        const textarea = (
          <textarea
            {...inputProps}
            ref={ref}
            aria-label={ariaLabel}
            className={cx(className, styles.textarea, styles[`size-${size}`])}
            onChange={(event) => onChange(event.target.value)}
          />
        );

        return label ? (
          <BaseInput.AnimationContainer label={label}>{textarea}</BaseInput.AnimationContainer>
        ) : (
          textarea
        );
      }}
    />
  );
};

export default TextArea;
